import type { JSX } from "react";

import { FileManagerPanel } from "../../../crm/components/file-manager-panel.js";
import { leadAttachmentsApi } from "./lead-attachments-api.js";

/**
 * A prospect's files, in the ported panel.
 *
 * A PORTAL-OWNED WRAPPER rather than a second panel: the ported
 * `FileManagerPanel` is the file surface the whole product uses, and
 * reimplementing it for prospects would give the two lists different search,
 * different pagination and a different viewer within a release. All this file
 * does is say WHICH attachments and WHICH permission key — the two things the
 * panel's new props exist for.
 *
 * `customerId` is the panel's prop name and the lead's id is what goes in it.
 * That reads oddly and is correct: crm-api's `Lead < Customer` is single-table
 * inheritance, so a lead IS a customer as far as the attachments controller is
 * concerned, and renaming the prop would edit a ported file for nothing.
 */
export function ProspectFilesPanel({ leadId }: { leadId: string }): JSX.Element {
  return (
    <FileManagerPanel
      customerId={leadId}
      api={leadAttachmentsApi}
      scope="prospect"
      title="Files"
    />
  );
}
